var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignatureActionPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 17.2852V32.5C32.5 33.4946 32.1049 34.4484 31.4017 35.1517C30.6984 35.8549 29.7446 36.25 28.75 36.25H11.25C10.2554 36.25 9.30161 35.8549 8.59835 35.1517C7.89509 34.4484 7.5 33.4946 7.5 32.5V7.5C7.5 6.50544 7.89509 5.55161 8.59835 4.84835C9.30161 4.14509 10.2554 3.75 11.25 3.75H18.9648C19.6277 3.7501 20.2633 4.01341 20.732 4.48203L31.768 15.518C32.2366 15.9867 32.4999 16.6223 32.5 17.2852Z",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.375V13.75C20 14.413 20.2634 15.0489 20.7322 15.5178C21.2011 15.9866 21.837 16.25 22.5 16.25H31.875M13.75 22.5H26.25M13.75 28.75H26.25",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureActionPending);
export default __webpack_public_path__ + "static/media/signature-action-pending.78b9be693ffdf3936a65b7c6cd0971bd.svg";
export { ForwardRef as ReactComponent };